<template>
  <v-app-bar app dark fixed :clippedLeft="true" style="z-index: 5">
    <!-- Home (ícone da raposa) -->
    <v-toolbar-title class="headline text-uppercase mr-4">
      <div>
        <router-link :to="homeItem.to">
          <v-img
            :src="require('../assets/logo-oderon-bw-40.png')"
            height="40"
            width="40"
          />
        </router-link>
      </div>
    </v-toolbar-title>

    <!-- Barra principal e submenus -->
    <OMainMenuBar :items="mainItems" />

    <BoltButton />

    <v-spacer></v-spacer>

    <!-- Menu de account -->
    <v-toolbar-items>
      <OMainMenu :items="accountItems" :nudge-width="50">
        <template v-slot:default>
          <v-icon dark class="mr-3">mdi-account-circle</v-icon>
          <div>{{ displayName }}</div>
          <v-icon dark>mdi-menu-down</v-icon>
        </template>
      </OMainMenu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import MenuStore from './menu/MenuStore.js'
import TheUser from 'oderon-vue/auth/TheUser'
import BoltButton from './bolt/BoltButton.vue'

export default {
  components: { BoltButton },
  computed: {
    homeItem() {
      return MenuStore.homeItem
    },
    mainItems() {
      return MenuStore.mainItems
    },
    accountItems() {
      return MenuStore.accountItems
    },
    displayName() {
      return TheUser.user && TheUser.user.login
    }
  }
}
</script>

<style></style>
